import { AddOns, HelfSettings } from './client-types';

export const addonsViewValues = {
  FAMILY: 'Life Story',
  DEMENTIA: 'Dementia',
  VIDEO_CALL: 'Video Calls',
  VIDEO_MESSAGE: 'Video Messages',
  HELF: 'Helf',
}


export const availableLicenses: Record<string, string> = {
  '-1': 'None',
  0: 'Demo plan',
  1: '5 streams',
  2: '10 streams',
  3: '15 streams',
  4: '20 streams',
  5: '25 streams'
}

/** @deprecated Use `Facilty` from `@resparke/models/client-types` instead. */
export interface Facility {
  id: string;
  organisationId: string;
  name: string;
  displayName: string;
  legacyFacilityId?: string;
  passwordResetEmail?: string;
  address: Address;
  country: string;
  license: number;
  addOns: AddOns[];
  residentsUploadStatus: 'PENDING' | undefined;
  subscription: MediaSubscription
  temporaryUnlockCode?: string;
  residentLimit: number;
  contentExclusions?: string[];
  archived: boolean;
  helf?: HelfSettings;
}
export interface Address {
  address: string;
  city: string;
  state: string;
  postcode: string;
  country: string;
}

export interface MediaSubscription {
  provider: string;
  activatedDateUTC: string;
  startDateUTC: string;
  expiryDateUTC: string;
  userId: string;
  planCode: string;
  country: string;
  recurringFee: number;
  currency: string;
  subscriptionStartDate: string;
  status: MediaSubscriptionStatus;
  autoRenew: boolean;
}

export enum MediaSubscriptionStatus {
  ACTIVE = 'ACTIVE',
  SCHEDULED = 'SCHEDULED',
  EXPIRED = 'EXPIRED',
  CANCELLED = 'CANCELLED',
  NONE = 'NONE',
}
